const FEATURES = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站漫画均支持高清分辨率阅读，画面细节清晰锐利，为漫迷还原最真实的漫画原稿质感，每一格分镜都纤毫毕现。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '编辑团队每日追踪韩漫、日漫、国漫最新连载进度，第一时间同步更新热门漫画最新章节，让你追更不落人后。',
  },
  {
    icon: 'ri-grid-line',
    title: '分类齐全',
    desc: '涵盖恋爱、奇幻、热血、悬疑、搞笑、治愈等全部风格分类，按类型、地区、热度多维度筛选，精准定位你的口味。',
  },
  {
    icon: 'ri-coin-line',
    title: '完全免费',
    desc: '所有漫画内容完全免费在线阅读，无需付费订阅，支持下拉式阅读模式，流畅翻页不卡顿，畅享全集完整版体验。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '漫迷社区',
    desc: '汇聚百万漫迷，每部作品下方均可查看热门评论与讨论，和同好一起交流剧情、分享观点，发现更多冷门佳作。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择香蕉漫画
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            用心打造属于漫迷的高品质阅读空间，让每一部漫画都能被更多人看见
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((item, idx) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}